import { useSyncExternalStore } from 'react';

// Tailwind `sm` breakpoint: below 640px we swap data grids for mobile card lists.
const MOBILE_QUERY = '(max-width: 639px)';
const subscribe = (cb: () => void) => {
  const mql = window.matchMedia(MOBILE_QUERY);
  mql.addEventListener('change', cb);
  return () => mql.removeEventListener('change', cb);
};
const getSnapshot = () => window.matchMedia(MOBILE_QUERY).matches;
const getServerSnapshot = () => false;

export function useIsMobile() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
